import { createSlice } from "@reduxjs/toolkit";
import * as actions from "../action/user";
import * as types from "../../types/user";
import { setCookie, eraseCookie } from "../../helpers/cookies";
import Toast from "../../helpers/Toast";
import { Node, Edge } from "reactflow";
// import Swal from "sweetalert2";
// import {
//   changePassword,
//   changeSecurityPassword,
//   updateProfileInfo,
// } from "../action/user";

type initialState = {
  isAuth: boolean;
  memberId: number;
  username: string;
  fullname: string;
  roleCode: string;
  roleId: number;
  status: number;
  memberType: number;
  registerCountry: number;
  ranking: number;
  rank_Name: string;
  warehouseId: number;
  menuList: {
    id: number;
    text: string;
    url: string;
    iconPath: string;
    parentId: number;
    virtualParentId: number;
    sort: number;
  }[];
  sponsorGenealogy: types.SponsorGenealogy[];
  profileDetail: types.profileDetailResponse;
  bankInformation: types.bankInformationResponse[];
  placementStore: {
    nodes: (
      | Node<types.PlcementNodeType, "downline">
      | Node<types.EmptyNodeType, "empty">
    )[];
    edges: Edge[];
    selectedIds: string[];
  };
};
const userSlide = createSlice({
  name: "user",
  initialState: {
    isAuth: false,
    memberId: 0,
    username: "",
    fullname: "",
    roleCode: "",
    roleId: 0,
    status: 0,
    memberType: 0,
    registerCountry: 0,
    ranking: 0,
    rank_Name: "",
    warehouseId: 0,
    menuList: [],
    sponsorGenealogy: [],
    profileDetail: {} as types.profileDetailResponse,
    bankInformation: [],
    placementStore: {
      nodes: [],
      edges: [],
      selectedIds: [],
    },
  } as initialState,
  reducers: {
    // register: {
    //     reducer: (state, action: PayloadAction<string>) => {
    //         // state.push(action.payload)
    //     },
    //     prepare: actions.register,
    // },
    // login: {
    //     reducer: (state, action: PayloadAction<string>) => {
    //         // state.push(action.payload)
    //     },
    //     prepare: actions.login,
    // }
  },
  extraReducers(builder) {
    builder
      .addCase(actions.login.fulfilled, (state, action) => {
        if (action.payload) {
          setCookie("authToken", action.payload.token, 1);
          state.isAuth = true;
          state.memberId = action.payload.memberId;
          state.username = action.payload.username;
          state.fullname = action.payload.fullname;
          state.roleCode = action.payload.roleCode;
          state.roleId = action.payload.roleId;
          state.status = action.payload.status;
          state.memberType = action.payload.memberType;
          state.registerCountry = action.payload.registerCountry;
          state.ranking = action.payload.ranking;
          state.rank_Name = action.payload.rank_Name;
          state.warehouseId = action.payload.warehouseId;
          state.menuList = action.payload.menuList;
        } else {
          state.isAuth = false;
          eraseCookie("authToken");
          state.memberId = 0;
          state.username = "";
          state.fullname = "";
          state.roleCode = "";
          state.roleId = 0;
          state.status = 0;
          state.memberType = 0;
          state.registerCountry = 0;
          state.ranking = 0;
          state.rank_Name = "";
          state.warehouseId = 0;
          state.menuList = [];
        }
      })
      .addCase(actions.login.rejected, (state, action) => {
        state.isAuth = false;
        eraseCookie("authToken");
        state.memberId = 0;
        state.username = "";
        state.fullname = "";
        state.roleCode = "";
        state.roleId = 0;
        state.status = 0;
        state.memberType = 0;
        state.registerCountry = 0;
        state.ranking = 0;
        state.rank_Name = "";
        state.warehouseId = 0;
        state.menuList = [];
        Toast.fire({
          icon: "error",
          title: "Fail to login",
        });
      })
      .addCase(actions.refreshToken.fulfilled, (state, action) => {
        if (action.payload.isAuth) {
          setCookie("authToken", action.payload.profile!.token, 1);
          state.isAuth = true;
          state.memberId = action.payload.profile!.memberId;
          state.username = action.payload.profile!.username;
          state.fullname = action.payload.profile!.fullname;
          state.roleCode = action.payload.profile!.roleCode;
          state.roleId = action.payload.profile!.roleId;
          state.status = action.payload.profile!.status;
          state.memberType = action.payload.profile!.memberType;
          state.registerCountry = action.payload.profile!.registerCountry;
          state.ranking = action.payload.profile!.ranking;
          state.rank_Name = action.payload.profile!.rank_Name;
          state.warehouseId = action.payload.profile!.warehouseId;
          state.menuList = action.payload.profile!.menuList;
        } else {
          state.isAuth = false;
          eraseCookie("authToken");
          state.memberId = 0;
          state.username = "";
          state.fullname = "";
          state.roleCode = "";
          state.roleId = 0;
          state.status = 0;
          state.memberType = 0;
          state.registerCountry = 0;
          state.ranking = 0;
          state.rank_Name = "";
          state.warehouseId = 0;
          state.menuList = [];
        }
      })
      .addCase(actions.refreshToken.rejected, (state, action) => {
        state.isAuth = false;
        eraseCookie("authToken");
        state.memberId = 0;
        state.username = "";
        state.fullname = "";
        state.roleCode = "";
        state.roleId = 0;
        state.status = 0;
        state.memberType = 0;
        state.registerCountry = 0;
        state.ranking = 0;
        state.rank_Name = "";
        state.warehouseId = 0;
        state.menuList = [];
        Toast.fire({
          icon: "error",
          title: "Fail to refresh token",
        });
      })
      .addCase(actions.logout.fulfilled, (state, action) => {
        state.isAuth = false;
        eraseCookie("authToken");
        state.memberId = 0;
        state.username = "";
        state.fullname = "";
        state.roleCode = "";
        state.roleId = 0;
        state.status = 0;
        state.memberType = 0;
        state.registerCountry = 0;
        state.ranking = 0;
        state.rank_Name = "";
        state.warehouseId = 0;
        state.menuList = [];
      })
      .addCase(actions.getSponsorGenealogy.fulfilled, (state, action) => {
        state.sponsorGenealogy = action.payload;
      })
      .addCase(actions.getSponsorGenealogy.rejected, (state, action) => {
        state.sponsorGenealogy = [];
      })
      .addCase(actions.getProfileDetail.fulfilled, (state, action) => {
        state.profileDetail = action.payload;
      })
      .addCase(actions.getProfileDetail.rejected, (state, action) => {
        state.profileDetail = {} as types.profileDetailResponse;
        Toast.fire({
          icon: "error",
          title: "Fail to Get Profile Information",
        });
      })
      .addCase(actions.getBankInformation.fulfilled, (state, action) => {
        state.bankInformation = action.payload;
      })
      .addCase(actions.getBankInformation.rejected, (state, action) => {
        state.bankInformation = [];
        Toast.fire({
          icon: "error",
          title: "Fail to Get Bank Information",
        });
      })
      .addCase(actions.getIdByMemberId.fulfilled, (state, action) => {})
      .addCase(actions.getIdByMemberId.rejected, (state, action) => {
        Toast.fire({
          icon: "error",
          title: "Fail to get ID by Username",
        });
      })
      .addCase(actions.updateBankInfo.fulfilled, (state, action) => {
        Toast.fire({
          icon: "success",
          title: "Success Update",
        });
      })
      .addCase(actions.updateBankInfo.rejected, (state, action) => {
        Toast.fire({
          icon: "error",
          title: "Fail to Update",
        });
      })
      .addCase(actions.updateProfileInfo.fulfilled, (state, action) => {
        Toast.fire({
          icon: "success",
          title: "Success Update",
        });
      })
      .addCase(actions.updateProfileInfo.rejected, (state, action) => {
        Toast.fire({
          icon: "error",
          title: "Fail to Update",
        });
      })
      .addCase(actions.changePassword.fulfilled, (state, action) => {
        if (action.payload.status) {
          Toast.fire({
            icon: "success",
            title: "Success Change Password",
          });
        } else {
          Toast.fire({
            icon: "error",
            title: "Fail to Change Password",
          });
        }
      })
      .addCase(actions.changePassword.rejected, (state, action) => {
        Toast.fire({
          icon: "error",
          title: "Fail to Change Password",
        });
      })
      .addCase(actions.changeSecurityPassword.fulfilled, (state, action) => {
        if (action.payload.status) {
          Toast.fire({
            icon: "success",
            title: "Success Change Security Password",
          });
        } else {
          Toast.fire({
            icon: "error",
            title: "Fail to Change Security Password",
          });
        }
      })
      .addCase(actions.changeSecurityPassword.rejected, (state, action) => {
        Toast.fire({
          icon: "error",
          title: "Fail to Change Security Password",
        });
      })
      .addCase(actions.getPlacementGenealogy.fulfilled, (state, action) => {
        if (!state.placementStore) {
          state.placementStore = {
            nodes: [],
            edges: [],
            selectedIds: [],
          };
        }
        state.placementStore.nodes = action.payload.nodes;
        state.placementStore.edges = action.payload.edges;
      })
      .addCase(actions.getPlacementGenealogy.rejected, (state, action) => {
        state.placementStore.nodes = [];
        state.placementStore.edges = [];
        Toast.fire({
          icon: "error",
          title: "Fail to get placement data",
        });
      })
      .addCase(actions.hoverPlacementNode, (state, action) => {
        state.placementStore.selectedIds = action.payload;
      })
      .addCase(actions.clearPlacementNodeHover, (state, action) => {
        state.placementStore.selectedIds = [];
      });
  },
});

export const {} = userSlide.actions;
export default userSlide.reducer;
